export enum TruefillRequestType {
  FillRequest = 'fill_request',
}
